import axios from 'axios';
import _ from 'lodash';

const STRIPE_TERMS_ACCEPTED_STORAGE_KEY = 'stripe_tc_accepted';


const stripeClient = axios.create({
  baseURL: process.env.VUE_APP_STRIPE_URL,
  timeout: process.env.VUE_APP_HTTP_REQUEST_TIMEOUT,
});

const defaultState = {
  countries: [],
  stripeInstance: null,
  areTermsAccepted: false,
  stripeAxiosClient: stripeClient,
  bookingChannelConfig: window.bookingChannelConfig,
};

const methods = {
  areTermsAccepted: (state) => {
    const storedValue = localStorage.getItem(STRIPE_TERMS_ACCEPTED_STORAGE_KEY);

    if (storedValue === 'true') {
      state.areTermsAccepted = true;
    }

    return state.areTermsAccepted;
  },
  getCurrencies: state => (countryCode) => {
    if (!countryCode) {
      return [];
    }

    const found = state.countries.find(country => country.id === countryCode);
    if (!found) {
      return [];
    }

    return Object.keys(found.supported_bank_account_currencies)
      .map(currency => currency.toUpperCase());
  },

  getCountries: state => state.countries.map(country => country.id.toUpperCase()),

  getBankInfoFormat: () => (countryCode, currencyCode) => {
    if (!countryCode) {
      return 'default';
    }

    if (countryCode && countryCode.toUpperCase() === 'CA') {
      return 'transit';
    }
    if (currencyCode && currencyCode.toLowerCase() === 'eur') {
      return 'iban';
    }

    return 'default';
  },

  getStripeJs: (state) => {
    if (!state.stripeInstance) {
      const { publishableKey } = window.bookingChannelConfig.payment.configuration;
      // eslint-disable-next-line no-undef
      state.stripeInstance = Stripe(publishableKey);
    }
    return state.stripeInstance;
  },
};

const actions = {
  acceptTermsAndConditions(context) {
    localStorage.setItem(STRIPE_TERMS_ACCEPTED_STORAGE_KEY, 'true');
    context.commit('acceptTermsAndConditions');
  },
  createToken: async (context, account) => {
    const result = await context.getters.getStripeJs.createToken('bank_account', _.omitBy({
      country: account.country,
      currency: account.currency.toLowerCase(),
      routing_number: account.routingNumber,
      account_number: account.accountNumber,
      account_holder_name: account.accountHolderName,
      account_holder_type: 'company',
    }, _.isEmpty));

    if (result.error) {
      context.dispatch('globalMessages/addError',
        { message: result.error.message },
        { root: true });
      return null;
    }

    return result.token;
  },

  loadCountries: async (context) => {
    const { publishableKey } = window.bookingChannelConfig.payment.configuration;

    const response = await stripeClient.get('/v1/country_specs', {
      params: {
        limit: 100,
      },
      headers: {
        Authorization: `Bearer ${publishableKey}`,
      },
    });

    context.commit('loadCountries', response.data.data);
  },
  // eslint-disable-next-line no-return-await
  retrieveCountrySpec: async (context, { countryId }) => {
    const { publishableKey } = context.state.bookingChannelConfig.payment.configuration;
    // eslint-disable-next-line no-return-await
    return await context.state.stripeAxiosClient.get(`/v1/country_specs/${countryId}`, {
      headers: {
        Authorization: `Bearer ${publishableKey}`,
      },
    });
  },
};

const mutations = {
  acceptTermsAndConditions(state) {
    state.areTermsAccepted = true;
  },
  loadCountries: (state, countries) => {
    state.countries = countries;
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters: methods,
  actions,
  mutations,
  STRIPE_TERMS_ACCEPTED_STORAGE_KEY,
};
